import React, { useState } from 'react';
import { browserState, SBBuild } from '@smart-builder/util';
import { Icon } from './Icon';
import { SBButton } from './SBButton';
import './DebugMode.scss';

export const DebugMode: React.FC = () => {
  const [loggingEnabled, setLoggingEnabled] = useState(browserState.enabled());
  const toggleLoggingEnabled = () =>
    setLoggingEnabled(loggingEnabled => {
      const nextLoggingEnabled = !loggingEnabled;
      browserState.set(nextLoggingEnabled);
      return nextLoggingEnabled;
    });

  return (
    <div className="debug-content">
      <Icon icon="bug-slash" />
      <h3>Application Details</h3>
      {Object.entries(SBBuild).map(([key, value]) => (
        <div className="detail-item" key={key}>
          <b>{key}</b>: {value}
        </div>
      ))}
      <hr />
      <div className="logging-option">
        <div>
          <h4>Logging</h4>
          <span className={loggingEnabled ? 'text-success' : ''}>
            Currently {loggingEnabled ? 'Enabled' : 'Disabled'}
          </span>
        </div>
        <SBButton variant="outline" onClick={toggleLoggingEnabled}>
          {loggingEnabled ? 'Disable' : 'Enable'}
        </SBButton>
      </div>
    </div>
  );
};
